import { useContext } from "react" 
import { CancelButton, CommandButton, Loading } from "components"
import { ActionButton } from "../components"
import { AttachmentModal, InputSection } from "./components"
import { AccountProvider } from "contexts"
import { PoContext } from "./contexts"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import moment from "moment"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import { useApi } from "utils"
import { type FormType, usePoDetail, validationSchema, fetchCurrentBalance } from "./utils"
import { Print } from "./Edit"

export default function DepositVendor(): JSX.Element {
  const { purchase_order_id } = useParams<{ purchase_order_id: string }>()
  const { data, isLoading } = usePoDetail(purchase_order_id!)

  if (isLoading || !data) { return <Loading loading={isLoading} /> }

  return (
    <PoContext.Provider value={data}>
      <AccountProvider>
        <FormSection />
      </AccountProvider>
    </PoContext.Provider>
  )
}

function FormSection(): JSX.Element {
  const api = useApi()
  const data = useContext(PoContext)
  const navigate = useNavigate()
  const { purchase_order_id } = useParams<{ purchase_order_id: string }>()

  const datapo = data.datapo

  const defaultValues: FormType = {
    _balance: 0,
    amount: 0,
    coa_id: "",
    memo: "Payment deposit transaction",
    no_cheque: "",
    trx_code: "",
    transaction_date: moment().format("YYYY-MM-DD"),
    vendor_id: datapo.vendor_id,
    imgPath: []
  }
  const onSubmit = (value: FormType) => {
    const finalValue = {
      purchase_order_id,
      coa_id: value.coa_id,
      vendor_id: value.vendor_id,
      location_id: datapo.location_id,
      project_id: null,
      trx_code: value.trx_code,
      transaction_date: value.transaction_date,
      amount: value.amount,
      memo: value.memo,
      no_cheque: value.no_cheque,
      imgPath: value.imgPath || []
    }

    return new Promise<void>((resolve) => {
      fetchCurrentBalance(api, purchase_order_id!).then((res) => {
        if (res.totaldeposit + finalValue.amount > res.totalpo) {
          toast.error("All deposit amount must be lower or equal to total amount of the purchase order")
          return resolve()
        }

        toast
          .promise(api.post("/depositvendor/add", finalValue), {
            loading: "Loading...",
            success: (res) => res.data.message,
            error: (err) =>
              err.response.data.detail?.message ?? err.response.data.message
          })
          .then(() => {
            navigate(-1)
          })
          .catch(() => {})
          .finally(resolve)
      })
    })
  }
  const methods = useForm<FormType>({
    defaultValues,
    resolver: yupResolver(validationSchema)
  })

  const trxCode = localStorage.getItem("trx_code_deposit_vendor")

  return (
    <FormProvider {...methods}>
      <InputSection
        actionsection={
          <ActionButton>
            <section className="flex flex-wrap gap-3">
              <Print trxCode={trxCode!} />
              <AttachmentModal code={trxCode!} /> 
            </section>

            <section className="flex flex-wrap gap-3">
              <CancelButton />

              <CommandButton
                actiontype="save"
                loading={methods.formState.isSubmitting ? "true" : undefined}
                onClick={methods.handleSubmit(onSubmit)}
              />
            </section>
          </ActionButton>
        }
      />
    </FormProvider>
  )
}
